import { createSelector } from '@ngrx/store';
import { routerState } from '@shared/state/router/selectors/root';

export const isMovingFromLocationToCheckout = (prevRegExp: RegExp = /\/locations\/\d+\/details$/) =>
    createSelector(routerState, (router: OLO.State.Router) => {
        const prevMatch = prevRegExp.test(router?.previous?.url ?? '');
        const currentMatch = router?.current?.url?.startsWith('/checkout') ?? false;

        return prevMatch && currentMatch;
    });
